export default __webpack_public_path__ + "media/zurb/fonts/PixelifySans-Regular-757beebb754a8d5219199c9e391e1922.ttf";